import { ToolAttributes, ToolName } from "@nova/constants"
import { createAction } from "@reduxjs/toolkit"

export const setSelectedTool = createAction<
    { toolName: ToolName; tool: ToolAttributes } | undefined
>("toolbox/setSelectedTool")
